import { useEffect } from 'react';
import AppRoutes from './router';
import ErrorBoundary from './utils/errorBoundary';
import { DataProvider } from './utils/store';
import { AuthProvider } from './middleware/authMiddleware';
import TokenExpiryPopup from './components/tokenExpiryPopUp';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <DataProvider>
          <TokenExpiryPopup />
          <AppRoutes />
        </DataProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;